import { TypeA, TypeA1, TypeA2, TypeAM, TypeB } from '@yme/assets/icons/license-types';
export const SUCCESS_STATUS = 'success';
export const ERROR_STATUS = 'error';
export const CART_URL = 'checkout.html#cart';
export const CART_URL_PUBLISH = 'checkout/#cart';
export const NOT_FOUND_URL = '404.html';
export const CART_PAGE_URL = 'checkout.html';
export var ProductType;
(function (ProductType) {
    ProductType["UNIT"] = "Unit";
    ProductType["APPAREL"] = "Apparel";
    ProductType["ACCESSORY"] = "Accessory";
})(ProductType || (ProductType = {}));
export var ProductUnitType;
(function (ProductUnitType) {
    ProductUnitType["MOTORCYCLES"] = "motorcycles";
    ProductUnitType["SCOOTERS"] = "scooters";
    ProductUnitType["EBIKE"] = "eBike";
    ProductUnitType["BOAT"] = "boat";
    ProductUnitType["OUTBOARD_ENGINES"] = "outboardEngines";
    ProductUnitType["WAVE_RUNNERS"] = "waveRunners";
    ProductUnitType["SNOWMOBILES"] = "snowmobiles";
    ProductUnitType["OTHER"] = "other";
})(ProductUnitType || (ProductUnitType = {}));
export const DRIVER_LICENCE_ICONS = {
    A: TypeA,
    A1: TypeA1,
    A2: TypeA2,
    AM: TypeAM,
    B: TypeB,
};
export var AlignContent;
(function (AlignContent) {
    AlignContent["LEFT"] = "left";
    AlignContent["RIGHT"] = "right";
})(AlignContent || (AlignContent = {}));
export const MAILTO_PREFIX = 'mailto';
export const TEL_PREFIX = 'tel';
// Extra custom option
export const NA_VALUE = 'N/A';
export const UNIQUE_SIZE = 'Unique Size';
export const ONE_SIZE = 'One Size';
export const EMBARGO_EXTERNAL_ATTR = 'embargoExternal';
export const POPULARITY_INDEX_ATTR = 'popularityIndex';
export const DRIVER_LICENSE_ATTR = 'productDriverLicenceCategory';
export const INRIVER_ID = 'inriverId';
export const PRICE_EXTRA_INFORMATION = 'priceExtraInformation';
export const PRICE_EXTRA_INFORMATION_TOOLTIP_TEXT = 'priceExtraInformationTooltipText';
export const PRICE_HERO_INFORMATION = 'priceHeroInformation';
export const SEGMENT_PRICE_EXTRA_INFORMATION_TOOLTIP_TEXT = 'segmentPriceExtraInformationTooltipText';
export const YOUTUBE_ID_ATTR = 'youtubeIds';
export const HERO_YOUTUBE_ID_ATTR = 'heroYouTubeId';
export const YOUTUBE_ID_ACCESSORIES = 'youtubeIdsAccessories';
export const FEATURES_ATTR = 'features';
export const PRODUCTS_ATTRIBUTE = 'products';
export const REQUIRED_ITEMS_ATTRIBUTE = 'requiredItems';
export const ACCESSORIES_ATTRIBUTE = 'accessories';
export const PRODUCT_DETAILS_KEY = 'productDetails';
export const USPS_KEY = 'usps';
export const CONFLICTING_ITEMS_KEY = 'conflictingItems';
export const TECH_SPECIFICATIONS_NAME = 'techSpecifications';
export const PRODUCT_FACT_SHEET_URL = 'productFactSheetUrl';
export const MOUNTING_INFORMATION = 'mountingInformation';
export const MOUNTING_UNIT_CATEGORY_TYPES = 'mountingUnitCategoryTypes';
// request constants
export const CATEGORIES_ID = 'categories.id';
export const VARIANTS_COLLECTION = 'variants.attributes.collection';
export const VARIANTS_ACCESSORY_TYPE = 'variants.attributes.accessoryType';
export const VARIANTS_ACCESSORY_TYPE_EN = 'variants.attributes.accessoryType.en';
export const VARIANTS_GENDER = 'variants.attributes.gender';
export const VARIANTS_ATTR_SIZE = 'variants.attributes.size';
export const VARIANTS_ATTR_COLOUR_NAME = 'variants.attributes.colourName';
export const VARIANTS_ATTR_EMBARGO_EXTR_RELEASED = 'variants.attributes.embargoExternalReleased:true';
export const VARIANTS_PRICES_DISCOUNT = 'variants.prices.discounted.value.centAmount:exists';
// common
export const VARIANTS_DRIVER_LICENSE_CATEGORY = 'variants.attributes.productDriverLicenceCategory';
// ebikes
export const VARIANTS_EBIKE_RIDING_TYPE = 'variants.attributes.productEBikeRidingType';
export const VARIANTS_EBIKE_WHEEL_SIZE = 'variants.attributes.productEBikeWheelSize';
// motorcycles
export const VARIANTS_MOTORCYCLES_POWER = 'variants.attributes.productMotorcyclePower';
export const VARIANTS_MOTORCYCLES_LIMITED_POWER_VERSION = 'variants.attributes.productMotorcycleLimitedPowerVersion';
// scooters
export const VARIANTS_SCOOTERS_STORAGE = 'variants.attributes.productScooterStorage';
export const VARIANTS_SCOOTERS_POWER = 'variants.attributes.productScooterPower';
export const VARIANTS_SCOOTERS_ENGINE_SIZE = 'variants.attributes.productScooterEngine';
// wave runners
export const VARIANTS_WAVE_RUNNERS_ENGINE_SIZE = 'variants.attributes.productWaveRunnersEngineSize';
export const VARIANTS_WAVE_RUNNERS_SUPER_CHARGED = 'variants.attributes.productWaveRunnersSupercharger';
export const VARIANTS_WAVE_RUNNERS_DRY_WEIGHT = 'variants.attributes.productWaveRunnersDryWeight';
// boats
export const VARIANTS_BOATS_LENGTH = 'variants.attributes.productBoatLength';
export const VARIANTS_BOATS_TYPE = 'variants.attributes.productBoatType';
export const VARIANTS_BOATS_BRAND = 'variants.attributes.productBoatBrand';
export const VARIANTS_BOATS_HORSE_POWER_MIN = 'variants.attributes.productBoatHorsepowerMinRange';
export const VARIANTS_BOATS_HORSE_POWER_MAX = 'variants.attributes.productBoatHorsepowerMaxRange';
// Snowmobiles
export const VARIANTS_SNOWMOBILES_TYPE = 'variants.attributes.productSnowmobilesType';
export const VARIANTS_SNOWMOBILES_DISPLACEMENT = 'variants.attributes.productSnowmobilesDisplacement';
export const VARIANTS_SNOWMOBILES_CYLINDERS = 'variants.attributes.productSnowmobilesCylinders';
// Outboard Engines
export const VARIANTS_OUTBOARD_ENGINE_CONFIGURATION = 'variants.attributes.productOutboardEnginesCylinders';
export const VARIANTS_OUTBOARD_ENGINE_STEERING = 'variants.attributes.productOutboardEnginesSteering';
export const VARIANTS_OUTBOARD_ENGINE_WEIGHT_MIN = 'variants.attributes.productOutboardEnginesDryWeightMinRange';
export const VARIANTS_OUTBOARD_ENGINE_WEIGHT_MAX = 'variants.attributes.productOutboardEnginesDryWeightMaxRange';
// Accessory usage
export const VARIANTS_ATTR_USAGE = 'variants.attributes.accessoryUsage';
// Options (for sorting)
export const SORT_DESC_DIRECTION = 'desc';
export const VARIANT_SKU_DESC = 'variants.sku.desc';
export const SORT_ASC = `variants.attributes.embargoExternal.asc`; // note: 'oldest' to 'newest'
export const SORT_DESC = `variants.attributes.embargoExternal.desc`; // note: 'newest' to 'oldest'
export const SORT_PRICE_ASC = 'price.asc'; // 0 -> 10
export const SORT_PRICE_DESC = 'price.desc'; // 10 -> 0
// Sort option by recommended
export const SORT_PRODUCT_INDEX_ASC = 'variants.attributes.productIndex.asc';
export const SORT_PRODUCT_ABB_PRODUCT_NAME_LOCALIZED_ASC = 'variants.attributes.productABBProductNameLocalized.asc';
export const SORT_PRODUCT_YEAR_DESC = 'variants.attributes.productYear.desc';
export const SORT_POPULARITY_INDEX_DESC = 'variants.attributes.popularityIndex.desc';
export const VERSION_CAAS = 'caas';
export var FilterType;
(function (FilterType) {
    FilterType["CHECKLIST"] = "checklist";
    FilterType["RANGE"] = "range";
    FilterType["RANGE_MIN"] = "range_min";
    FilterType["RANGE_MAX"] = "range_max";
    FilterType["RADIO"] = "radio";
    FilterType["TOGGLE"] = "toggle";
})(FilterType || (FilterType = {}));
export var FacetId;
(function (FacetId) {
    FacetId["ACCESSORIES"] = "ACCESSORIES";
    FacetId["CLOTHING_MERCHANDISE"] = "CLOTHING_MERCHANDISE";
})(FacetId || (FacetId = {}));
// Configs for facets
export const FACETS_CONFIG = {
    ACCESSORIES: [
        {
            id: CATEGORIES_ID,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_COLLECTION,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_GENDER,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_ACCESSORY_TYPE,
            type: FilterType.CHECKLIST,
        },
    ],
    CLOTHING_MERCHANDISE: [
        {
            id: CATEGORIES_ID,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_GENDER,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_COLLECTION,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_ACCESSORY_TYPE,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_ATTR_SIZE,
            type: FilterType.CHECKLIST,
        },
        {
            id: VARIANTS_ATTR_COLOUR_NAME,
            type: FilterType.CHECKLIST,
        },
    ],
};
export const UNITS_WITHOUT_LICENCE = 'NotRequired';
export const DRIVER_LICENCE_MAP = {
    ALL: ['A', 'A1', 'A2', 'AM', 'B', UNITS_WITHOUT_LICENCE],
    A: ['A', 'A1', 'A2', 'AM', 'B', UNITS_WITHOUT_LICENCE],
    A1: ['A1', 'AM', 'B', UNITS_WITHOUT_LICENCE],
    A2: ['A1', 'A2', 'AM', 'B', UNITS_WITHOUT_LICENCE],
    AM: ['AM', UNITS_WITHOUT_LICENCE],
    B: ['AM', 'B', UNITS_WITHOUT_LICENCE],
};
export const DEFAULT_PER_PAGE_VALUES = [6, 12, 18, 32];
// Request constants of parameters
export const SORT_KEY = 'sort';
export const ALL_FACETS_KEY = 'allFacets';
export const SELECTED_FACETS_KEY = 'selectedFacets';
export const QUERY_KEY = 'query';
export const LIMIT_KEY = 'limit';
export const OFFSET_KEY = 'offset';
export const TEXT_KEY = 'text';
export const VERSION_KEY = 'version';
export const ARCHIVED_KEY = 'includeArchived';
export const TEST_RIDE_KEY = 'testRide';
export const PRODUCT_TYPE = 'productType';
export const EXTERNAL_ID_KEY = 'isExternalId';
export var QueryParams;
(function (QueryParams) {
    QueryParams["PAGE"] = "page";
    QueryParams["PER_PAGE"] = "perPage";
    QueryParams["SORT"] = "sort";
    QueryParams["SEARCH"] = "search";
    QueryParams["DISCOUNTED"] = "discounted";
    QueryParams["DISCOUNTED_MODE"] = "isDiscountMode";
    QueryParams["PRODUCT"] = "product";
    QueryParams["CART_ID"] = "cartId";
})(QueryParams || (QueryParams = {}));
export const HEADER_HEIGHT = {
    sm: '64px',
    md: '80px',
    lg: '80px',
};
export const COOKIE_ORDER_NUMBER_KEY = 'orderNumber';
// Product attributes
export const PCM_CODE = 'productPCMCode';
export const PRODUCT_YEAR = 'productYear';
export const PRODUCT_HAS_CONFIGURATOR = 'productHasConfigurator';
export const SOURCE_PARAM_NAME = 'source';
export const CONFIGURATOR_SOURCE_PARAM_VALUE = 'configurator';
export const CONFIGURATOR_PARAM_NAME = 'configurator';
export const CONFIGURATOR_PARAM_VALUE_ON = 'on';
export const CONFIGURATOR_URL_PARAM_NAME = 'configuratorUrl';
export const IS_PRESELECTED_PARAM_NAME = 'isPreselected';
export const MASTER_PRODUCT_SKU = 'masterProductSku';
export const ANALYTICS_ORDER_ID = 'ANALYTICS/ORDER_ID';
export const ANALYTICS_CART_ID = 'ANALYTICS/CART_ID';
export const ANALYTICS_CART_DEALER_ID = 'ANALYTICS/CART_DEALER_ID';
export const fieldsToExcludeFromConsent = ['hasError', 'isTouched', 'marketingAgreement'];
export const UK_PREFIX = '/gb/';
export const LAZY = 'lazy';
export const IMAGE_DEFAULT_ASPECT_RATIO = {
    width: 16,
    height: 9,
};
export const OPTANON_ALERT_BOX_CLOSED = 'OptanonAlertBoxClosed';
// pages
export const PDP_TYPE = 'yme/components/pages/product-details-page';
export const PDP_CLOTHING_TYPE = 'yme/components/pages/clothing-and-merchandise-product-details-page';
export const PDP_ACCESSORIES_TYPE = 'yme/components/pages/accessories-product-details-page';
export const PLP_TYPE = 'yme/components/pages/product-listing-page';
export const TEST_RIDE_PLP_TYPE = 'yme/components/pages/test-ride-product-listing-page';
export const CLP_TYPE = 'yme/components/pages/category-landing-page';
export const TEST_RIDE_CLP_TYPE = 'yme/components/pages/test-ride-category-landing-page';
export const ACP_TYPE = 'yme/components/pages/accessories-category-landing-page';
export const NCP_TYPE = 'yme/components/pages/nav-content-page';
export const CP_TYPE = 'yme/components/pages/content-page';
export const CMP_TYPE = 'yme/components/pages/clothing-and-merchandise-category-landing-page';
export const PAGE_TYPE = 'yme/components/pages/page';
export const EDP_TYPE = 'yme/components/pages/experience-details-page';
export const NEWS_EVENT_TYPE = 'yme/components/pages/news-event-page';
export const OFFERS_PROMO_TYPE = 'yme/components/pages/offers-promo-page';
export const NEWS_CLP_TYPE = 'yme/components/pages/news-content-listing-page';
export const EVENTS_CLP_TYPE = 'yme/components/pages/events-content-listing-page';
export const OFFERS_PROMO_LP_TYPE = 'yme/components/pages/offers-promo-listing-page';
export const EXPERIENCES_LP_TYPE = 'yme/components/pages/experiences-listing-page';
export const PARTNERS_LP_TYPE = 'yme/components/pages/partners-listing-page';
export const AMBASSADORS_LP_TYPE = 'yme/components/pages/ambassadors-listing-page';
export const TEST_RIDE_FORM_TYPE = 'yme/components/pages/test-ride-form-page';
export const COMPARISON_TYPE = 'yme/components/pages/comparison-page';
export const OWNER_MANUALS_TYPE = 'yme/components/pages/owner-manuals-page';
export const DEALER_LOCATOR_TYPE = 'yme/components/pages/dealer-locator-page';
export const RETURN_FORM_TYPE = 'yme/components/pages/return-form-page';
export const HOME_TYPE = 'yme/components/pages/home-page';
export const COOKIE_SETTINGS_TYPE = 'yme/components/pages/cookie-settings-page';
export const MAINTENANCE_TYPE = 'yme/components/pages/maintenance-page';
export const GLOBAL_SEARCH_RESULTS_TYPE = 'yme/components/pages/global-search-results-page';
export const RENTAL_LOCATOR_TYPE = 'yme/components/pages/rental-locator-page';
export const MAX_EMAIL_INPUT_CHARS_60 = 60;
export const MAX_EMAIL_INPUT_CHARS_80 = 80;
export const INPUT_MAX_LENGTH = {
    email: MAX_EMAIL_INPUT_CHARS_80,
    firstName: 40,
    lastName: 80,
    phoneNumber: 15,
    default: 100,
};
export const PERSONAL_DETAILS_INPUT_MAX_LENGTH = {
    email: MAX_EMAIL_INPUT_CHARS_60,
    firstName: 30,
    lastName: 30,
    phoneNumber: 15,
};
export const PERSONAL_DETAILS_INPUT_MIN_LENGTH = {
    firstName: 1,
    lastName: 1,
};
export const ADDITIONAL_COUNTRIES_MAP = {
    fr: ['gf', 'gp', 'mq', 'mc', 're'],
};
// Countries
export const ITALY_LOCALE = 'it';
export const SPAIN_LOCALE = 'es';
// Discounts
export const RELATIVE = 'relative';
export const ABSOLUTE = 'absolute';
export const DEALER_ID_KEY = 'dealerId';
export const DEALER_IDS_KEY = 'dealerIds';
export const SALESFORCE_DEALER_KEY = 'salesforceDealer';
export const SELECT_MODEL_MODAL_CASHED_DATA = 'selectModelModalCashedData';
export const CQ_EDITOR_LAYER_COOKIE = 'cq-editor-layer.page';
export var CqEditorLayer;
(function (CqEditorLayer) {
    CqEditorLayer["EDIT"] = "Edit";
    CqEditorLayer["LAYOUTING"] = "Layouting";
})(CqEditorLayer || (CqEditorLayer = {}));
export const HOURS_SYMBOL = 'h';
export const MINUTES_SYMBOL = 'm';
